/* istanbul ignore file */
export const PRODUCT_IMAGES_TABPANEL_ID_PREFIX = 'product-images-tabpanel-';
export const PRODUCT_IMAGES_TAB_ID_PREFIX = 'product-images-tab-';
export const PRODUCT_IMAGES_TABPANEL_CONTAINER_ID = 'product-images-tabpanel-container';
export const PROGRESS_INDICATOR_TEST_ID = 'progress-indicator';

export const ZOOM_PAN_WRAPPER_CLASS = 'zoom-pan-wrapper';
export const ZOOM_PAN_CONTENT_CLASS = 'zoom-pan-content';
